import React, { useState } from "react";
import { StyledForm } from "../Auth.styled";
import Logo from "../../assets/fortcore-icon.png";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../globalStyle/GlobalStyle";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import Parse from "../../api/ApiConfig";
import AuthLayout from "../../layout/AuthLayout";

function LoginScreen() {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [passwordShown, setPasswordShown] = useState(false);
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const user = await Parse.User.logIn(username, password);

			// Check if user is admin
			if (user.get("isAdmin")) {
				toast.success("Successfully Logged in");
				sessionStorage.setItem("isLoggedIn", user.get("isAdmin"));
				setLoading(false);
				navigate("/");
			} else {
				toast.error("Unauthorized, You don't have admin access");
				setLoading(false);
			}
		} catch (error) {
			console.log(error);
			if (error.message?.includes('XMLHttpRequest failed: "Unable to connect to the Parse API')) {
				toast.error("Oops! You are not connected to the internet.");
				setLoading(false);
			} else {
				toast.error(error.message);
				setLoading(false);
			}
		}
	};

	return (
		<AuthLayout>
			<img src={Logo} alt='' />
			<p className='subtext'>Admin Login</p>

			<StyledForm onSubmit={handleSubmit}>
				<label>Email Address</label>
				<input
					type='text'
					value={username}
					onChange={(e) => setUsername(e.target.value)}
					placeholder='Enter email'
					disabled={loading}
					required
				/>

				<label>Password</label>
				<div className='input_group'>
					<input
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						disabled={loading}
						placeholder='Enter password'
						type={passwordShown ? "text" : "password"}
						required
					/>
					<button className='input_icon' onClick={() => setPasswordShown(!passwordShown)} type='button'>
						{passwordShown ? <FaRegEye /> : <FaRegEyeSlash />}
					</button>
				</div>

				<div className='div'>
					<div className='forgot'>
						<Link to='/forgot-password'>Forgot your password?</Link>
					</div>

					<Button type='submit'>{!loading ? "Login" : <div className='loader'></div>}</Button>
				</div>
			</StyledForm>
		</AuthLayout>
	);
}

export default LoginScreen;
